var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15.5C17.75 16.1334 17.5167 16.7334 17.1334 17.1667C16.6667 17.7667 15.95 18.1334 15.1167 18.1334C14.2 18.1334 13.4167 17.6834 12.95 16.9834C12.65 16.5667 12.5 16.05 12.5 15.5167C12.5 14.0667 13.6667 12.9 15.1334 12.9C16.6 12.9 17.75 14.0667 17.75 15.5167V15.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 24.5C27.5 25.95 26.3333 27.1167 24.8667 27.1167C23.4 27.1167 22.25 25.95 22.25 24.5C22.25 23.9167 22.45 23.3834 22.7833 22.95C23.25 22.3 24 21.8834 24.8834 21.8834C25.7667 21.8834 26.5833 22.3334 27.05 23.0334C27.35 23.45 27.5 23.9667 27.5 24.5V24.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5501 22.6333L17.35 17.3666",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 14.9667L27.5 22.4667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 25.0166L12.7 17.3167",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 5H11.6667C7.98477 5 5 7.98477 5 11.6667V28.3333C5 32.0152 7.98477 35 11.6667 35H28.3333C32.0152 35 35 32.0152 35 28.3333V11.6667C35 7.98477 32.0152 5 28.3333 5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.05b8a2c7ba74b44620ea121e91bb4fd1.svg";
export { ForwardRef as ReactComponent };